import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "../util";

export const sendMessage = ({
  businessId,
  sender,
  receiver,
  name,
  mail,
  product,
  section,
  body,
  supplier,
  colleague,
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    sender: sender,
    receiver: receiver,
    name: name,
    mail: mail,
    product: product,
    section: section,
    body: body,
    supplier: supplier,
    colleague: colleague,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/admins/" + businessId + "/message",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const receiveMessage = ({ setMessages, businessId, setResponse }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/admins/" + businessId + "/message",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    params: {
      businessId: businessId,
    },
  };

  axios(config)
    .then(function (response) {
      setMessages(response.data);
      if (setResponse) setResponse(response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
};
